// removed by extract-text-webpack-plugin
module.exports = {"toolbox":"controls__toolbox-1E1vw","edit":"controls__edit-168il blocks__button-1iODk blocks__mini-Jb_UB","save":"controls__save-2UcbR blocks__button-1iODk blocks__mini-Jb_UB","cancel":"controls__cancel-1MgPY blocks__button-1iODk blocks__mini-Jb_UB"};


//////////////////
// WEBPACK FOOTER
// ./components/account/orders/current-order/editable-order/controls/controls.css
// module id = 757
// module chunks = 0